import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import OnboardingLandingSports from '../../onboarding/start/OnboardingLandingSports';
import { allowsFreeJoin } from '../../../util/discover-album-folder';
import getConfig from '../../../util/config';
import LogoPoweredBy from '../../global/LogoPoweredBy';

const propTypes = {
  albumFolder: PropTypes.shape({
    name: PropTypes.string,
    account: PropTypes.shape({
      name: PropTypes.string,
      organization_name: PropTypes.string,
    }),
  }).isRequired,
  onGetStarted: PropTypes.func.isRequired,
};

const DiscoverAlbumFolderStartSports = ({ albumFolder, onGetStarted }) => {
  const config = getConfig();

  return (
    <Fragment>
      <OnboardingLandingSports
        albumFolder={albumFolder}
        onGetStarted={onGetStarted}
        isFreeJoin={allowsFreeJoin(albumFolder)}
      />
      <a
        href={config.marcomUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="discovery-start-logo"
      >
        <LogoPoweredBy />
      </a>
    </Fragment>
  );
};

DiscoverAlbumFolderStartSports.propTypes = propTypes;

export default DiscoverAlbumFolderStartSports;
